import { omit, omitBy, isEqual, isUndefined } from 'lodash';
import { BusinessQuery } from '@/modules/dashboard/dashboardTypes';

const OMIT_KEYS = ['sort', 'sortField', 'queryType', 'user'];

const defaultQuery = {
	minDistance: 0,
	maxDistance: 40,
	limit: 50,
	skip: 0,
	sortField: 'score',
	sort: { score: -1 },
	count: true
};

export const isQueryDifferent = (newQuery: BusinessQuery): boolean => {
	const oldWithoutLocation = omitBy(
		omit(defaultQuery, OMIT_KEYS),
		isUndefined
	);

	const newWithoutLocation = omitBy(
		omit(newQuery, OMIT_KEYS),
		value =>
			isUndefined(value) || (Array.isArray(value) && value.length === 0)
	);

	return !isEqual(oldWithoutLocation, newWithoutLocation);
};
